import { StyledWhyKelu } from "./styles";

const WhyKelu = () => {
  return (
    <StyledWhyKelu>
      <span className="section-label">Why Kelu</span>

      <h2 className="section-title">
        Stop switching between disconnected apps.
      </h2>

      <h5 className="section-sub-title">
        Customer work is often spread across messaging, meetings, task managers,
        documents and forms. Kelu gives the entire relationship one home.
      </h5>

      <div className="problem-grid">
        <div className="panel">
          <h3>Without Kelu</h3>

          <div className="tool-list">
            <div className="tool">✕ WhatsApp</div>
            <div className="tool">✕ Email</div>
            <div className="tool">✕ Meeting apps</div>
            <div className="tool">✕ Task managers</div>
            <div className="tool">✕ Documents</div>
            <div className="tool">✕ Forms</div>
          </div>

          <p
            style={{
              color: "#6f687e",
              margin: "20px 0 0",
            }}
          >
            Information gets lost, work and personal life overlap, and customers
            receive a fragmented experience.
          </p>
        </div>

        <div className="panel with-kelu">
          <h3>With Kelu</h3>

          <div className="check">✓ One customer conversation</div>
          <div className="check">✓ One shared team workspace</div>
          <div className="check">✓ One place for meetings and follow-ups</div>
          <div className="check">✓ One secure customer experience</div>

          <p>
            Every customer relationship stays connected from the first message
            to the final outcome.
          </p>
        </div>
      </div>
    </StyledWhyKelu>
  );
};

export default WhyKelu;
